import React, { useEffect, useRef, useState } from 'react';
import {
	XEditButtonIcon,
	XTag,
	XThemeContainer,
	XThemeFilterButton,
	XThemeFilterCards,
	XThemeFilterCircleButton,
	XThemeInputText,
	XThemeLogsTags,
	XThemeTable,
	XThemeTag,
} from '../../styles/GlobalThemeStyle';
import { Row, Col, Space, Popover, Tooltip, Button, Grid } from 'antd';
import Header from '../../components/Header/Header';
import HeaderFile from '../../components/Header/HeaderFile';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import {
	XThemeBulkTags,
	XThemeEmptyBatche,
	XThemeStartCancelBTN,
} from './BatchesStyle';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {
	getBatchListApi,
	getBatchListReset,
} from '../../actions/getBatchListAction';
import moment from 'moment';
import { checkModulePermissions } from '../../utils/helper';
import {
	XTheme2InnerCard,
	XTheme2Para1,
	XThemeDashboardLottieCard,
} from '../Dashboard/DashboardStyleCQ';
import DashboardJson from '../../json/Reclaim.json';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
	XTheme2Table,
} from '../../styles/GlobalThemeStyleCQ';

const Batches = (props) => {
	const { getBatchListState = { apiState: '', data: [] }, getBatchList } =
		props;
	const [dataSource, setDataSource] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [tableLoading, setTableLoading] = useState(false);
	const [filters, setFilters] = useState({
		search: '',
		page: 1,
		limit: 10,
		sort: 'createdAt',
		sortDirection: 'descend',
	});
	const navigate = useNavigate();

	const columns = [
		{
			title: 'Batch Name',
			dataIndex: 'batchName',
			width: '20%',
			render: (text, record) => (
				<Link to={`/batch-details/${record.key}`}>{record.name}</Link>
			),
		},
		{
			title: 'Excel Name',
			dataIndex: 'excelName',
		},
		{
			title: 'No. of Cases',
			dataIndex: 'NoOfCases',
			align: 'center',
		},
		{
			title: 'Status',
			dataIndex: 'status',
			align: 'center',
			render: (status) => {
				// Convert status to lowercase for class name
				const statusClass = status.toLowerCase();

				// Format status text for display (capitalize first letter of each word)
				const formattedStatus = status
					.split('_')
					.map(
						(word) =>
							word.charAt(0).toUpperCase() +
							word.slice(1).toLowerCase(),
					)
					.join(' ');

				return (
					<XThemeBulkTags className={statusClass}>
						{formattedStatus}
					</XThemeBulkTags>
				);
			},
		},
		{
			title: 'Created On',
			dataIndex: 'createdOn',
			align: 'center',
			render: (date) => (
				<div className="showDate">
					{moment(date).format('DD-MM-YYYY')}
				</div>
			),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			align: 'center',
			render: (_, record) => (
				<Space>
					<Link to={`/batch-details/${record.key}`}>
						<XEditButtonIcon size="small" type="text">
							<img src="./images/view-icon.svg" alt="" />
						</XEditButtonIcon>
					</Link>
					{/* <Link to={`/edit-batch/${record.key}`}>
						<XEditButtonIcon size="small" type="text">
							<img src="./images/pencil.svg" alt="" />
						</XEditButtonIcon>
					</Link> */}
					{/* <XEditButtonIcon type="text">
						<img src="./images/delete-icon-card.svg" alt="" />
					</XEditButtonIcon> */}
				</Space>
			),
		},
	];

	useEffect(() => {
		if (getBatchListState.apiState === 'success') {
			setTableLoading(false);
			if (getBatchListState.data?.data?.length > 0) {
				const updatedData = [];
				setTotalRecords(getBatchListState.data.pagination.total);
				getBatchListState.data.data.map((item) => {
					const excelName = item.excel_url
						? decodeURIComponent(item.excel_url.split('/').pop())
						: '-';
					updatedData.push({
						key: item._id,
						name: item.batch_name,
						batchName: item.batch_name,
						excelName: excelName,
						NoOfCases: item?.total_cases || '-',
						status: item.status,
						createdOn: item.createdAt,
					});
				});
				setDataSource(updatedData);
			} else {
				setDataSource([]);
				setTotalRecords(0);
			}
		}
	}, [getBatchListState]);

	useEffect(() => {
		getBatchList(filters);
	}, [filters]);

	const handleTableChange = (pagination, filters, sorter) => {
		setTableLoading(true);
		setFilters({
			...filters,
			page: pagination.current,
			limit: pagination.pageSize,
		});
	};

	const handleSearch = (value) => {
		setTableLoading(true);
		if (value === '') {
			setFilters({
				...filters,
				search: '',
				page: 1,
			});
		} else {
			setFilters({
				...filters,
				search: value,
				page: 1,
			});
		}
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			<Col lg={24} xl={24} xs={0} md={0}>
				<Header headerTag="Batches" />
			</Col>
			<Col lg={0} xl={0} xs={24} md={24}>
				<HeaderFile />
			</Col>
			<XThemeContainer fluid>
				<Row gutter={[15, 15]} className="align-items-center mb-4">
					{/* <Col xs={24} sm={24} md={3} lg={2} className="text-center">
						<XThemeDashboardLottieCard
							className="caseManagementTitleAnimation"
							animationData={DashboardJson}
							loop={true}
						/>
					</Col> */}
					<Col
						xs={24}
						sm={24}
						md={12}
						lg={12}
						xl={12}
						className="text-center text-md-start"
					>
						<XTheme2MainTitle className="mb-2">
							Agent Maxx
						</XTheme2MainTitle>
						<XTheme2Para1>
							Oversee and administer the cases within the
							designated work loads.
						</XTheme2Para1>
					</Col>
					<Col
						xs={24}
						sm={24}
						md={12}
						lg={12}
						xl={12}
						className="text-center text-md-end"
					>
						{/* {checkModulePermissions(
							'batches',
						).sub_modules.includes('add-batch') ? ( */}

						{isMobile ? (
							<XTheme2Button
								shape="circle"
								size="large"
								className="noBackground borderColor"
								onClick={() => navigate('/create-workload')}
								icon={<PlusOutlined />}
							/>
						) : (
							<Link to="/create-workload">
								<XTheme2Button
									size="large"
									icon={<PlusOutlined />}
								>
									Create New Case
								</XTheme2Button>
							</Link>
						)}
						{/* ) : (
							<></>
						)} */}
					</Col>
				</Row>

				{dataSource.length === 0 &&
				getBatchListState.apiState === 'success' ? (
					<XThemeEmptyBatche
						image="/images/empty.svg"
						description={
							filters.search
								? 'No work load found matching your search'
								: 'No work load found. Create your first work load to get started!'
						}
					>
						<Link to="/create-workload">
							<XThemeFilterButton
								className="backgroundRevers mt-3"
								icon={<PlusCircleFilled />}
							>
								Create WorkLoad
							</XThemeFilterButton>
						</Link>
					</XThemeEmptyBatche>
				) : (
					<>
						<XTheme2InnerCard
							className="mb-3 withBackground"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col
										xs={24}
										sm={24}
										md={12}
										lg={12}
										className="mb-3 mb-md-0"
									>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Cases
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="mb-3 mb-sm-0 text-end"
									>
										<Space>
											<XThemeInputText
												size="large"
												allowClear
												placeholder="Search for Cases"
												defaultValue={
													filters.search || null
												}
												onChange={(e) =>
													handleSearch(e.target.value)
												}
												onKeyDown={(e) => {
													if (
														e.key === 'Enter' &&
														filters.search
													) {
														getBatchList({
															...filters,
															search: filters.search,
														});
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													if (filters.search) {
														getBatchList({
															...filters,
															search: filters.search,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
								</Row>
							</div>
							<XTheme2Table
								columns={columns}
								dataSource={dataSource}
								scroll={{ x: 991 }}
								className=""
								loading={
									tableLoading ||
									getBatchListState.apiState === 'loading'
								}
								onChange={handleTableChange}
								pagination={{
									total: totalRecords,
									pageSize: filters.limit,
									current: filters.page,
									showSizeChanger: true,
								}}
							/>
						</XTheme2InnerCard>
					</>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getBatchListState: state.getBatchList,
});

const mapDispatchToProps = (dispatch) => ({
	getBatchList: (data) => dispatch(getBatchListApi(data)),
	getBatchListReset: () => dispatch(getBatchListReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Batches);
